import { ReactElement } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import Button from '@Hotels-at-Home/hah-fe-core/dist/components/Button';
import Link from '@Hotels-at-Home/hah-fe-core/dist/components/Link';

const PillowsSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$pillowsSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$pillows' });

  return (
    <section className="base-section pillows-section hp-section">
      <Link href={tLink('pillows')}>
        <div className="pillows-content">
          <div className="pillows-image">
            <picture>
              <source srcSet="/images/homePage/fill.gif" media="(max-width: 660px)" />
              <img
                src="/images/homePage/pillowsSection/pillows.webp"
                alt={t('pillowsAlt')}
                width="762"
                height="863"
                loading="lazy"
                decoding="async"
                fetchPriority="low"
              />
            </picture>
          </div>
          <div className="content-section">
            <p>{t('tagline')}</p>
            <h3>
              <Trans i18nKey="title" t={t} components={{ span: <span /> }} />
            </h3>
            <p className="sub-copy">{t('description')}</p>
            <Button ariaLabel={t('pillowsAlt')}>{tButton('shopNow')}</Button>
          </div>
        </div>
      </Link>
    </section>
  );
};

export default PillowsSection;
